import { buildApiUrl } from '../../configs/api.js'

export default {
  postUrl() {
    return buildApiUrl('/tickets')
  },

  format(payload) {
    const { title, description, customerName, customerId, userType, priority } = payload || {}

    return {
      subject: title || '',
      message: description || '',
      priority: priority || 'normal',
      customerName: customerName || '',
      userId: customerId || null,
      userRole: userType || 'customer',
    }
  },

  parse(raw) {
    const response = raw || {}
    if (response.statusCode !== 201 && response.statusCode !== 200) {
      return {
        statusCode: response.statusCode || 500,
        message: response.message || 'Le serveur semble innaccessible',
        data: response.data || null,
      }
    }

    return {
      statusCode: 200,
      message: 'ok',
      data: {
        created: true,
      },
    }
  },
}
